import React from "react";
import { Input } from "@/components/ui/input";
import { Textarea } from "@/components/ui/textarea";
import { Label } from "@/components/ui/label";
import { Select, SelectTrigger, SelectValue, SelectContent, SelectItem } from "@/components/ui/select";

const fieldCls = "bg-surface/70 border-edge text-white placeholder:text-faint focus-visible:ring-gold focus-visible:border-gold h-11";

export function TextField({ label, name, value, onChange, type = "text", placeholder, required, testId, className = "" }) {
  return (
    <div className={className}>
      {label && <Label className="text-sm text-white/85 mb-1.5 block">{label}{required && <span className="text-brandred"> *</span>}</Label>}
      <Input
        type={type}
        value={value ?? ""}
        onChange={(e) => onChange(name, e.target.value)}
        placeholder={placeholder}
        data-testid={testId || `field-${name}`}
        className={fieldCls}
      />
    </div>
  );
}

export function AreaField({ label, name, value, onChange, placeholder, rows = 4, testId, className = "" }) {
  return (
    <div className={className}>
      {label && <Label className="text-sm text-white/85 mb-1.5 block">{label}</Label>}
      <Textarea
        value={value ?? ""}
        onChange={(e) => onChange(name, e.target.value)}
        placeholder={placeholder}
        rows={rows}
        data-testid={testId || `field-${name}`}
        className="bg-surface/70 border-edge text-white placeholder:text-faint focus-visible:ring-gold focus-visible:border-gold"
      />
    </div>
  );
}

export function SelectField({ label, name, value, onChange, options, placeholder = "Select…", required, testId, className = "" }) {
  return (
    <div className={className}>
      {label && <Label className="text-sm text-white/85 mb-1.5 block">{label}{required && <span className="text-brandred"> *</span>}</Label>}
      <Select value={value || ""} onValueChange={(v) => onChange(name, v)}>
        <SelectTrigger data-testid={testId || `field-${name}`} className={fieldCls}>
          <SelectValue placeholder={placeholder} />
        </SelectTrigger>
        <SelectContent className="bg-charcoal border-edge text-white max-h-72">
          {options.map((o) => {
            const val = typeof o === "string" ? o : o.value;
            const lab = typeof o === "string" ? o : o.label;
            return <SelectItem key={val} value={val} className="focus:bg-gold/15 focus:text-gold">{lab}</SelectItem>;
          })}
        </SelectContent>
      </Select>
    </div>
  );
}
